
define('ldsh!modules/accounts/users/detail/modalLoginHistory/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="modal fade" id="modalLoginHistory" tabindex="-1" role="dialog" aria-labelledby="modalLoginHistoryLabel" aria-hidden="true">\n  <div class="modal-dialog modal-dialog-login-history">\n    <div class="modal-content">\n      <div class="modal-header">\n        <div class="close-wrapper">\n          <a class="close" data-dismiss="modal">\n            <i class="ri-close-line"></i>\n          </a>\n        </div>\n        <h4 class="i18n modal-title" data-i18n="ACCOUNTS.USERS.LBL_LIST_LAST_LOGIN"></h4>\n        <div style="display: none" id="notification-area-modal"></div>\n      </div>\n\n      <div class="modal-body modal-body-login-history">\n        <table class="table table-striped e100" cellspacing="0">\n          <thead>\n          <tr class="bottom-heading">\n            <th><span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_IS_VALID"></span></th>\n            <th><span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_SERVICE"></span></th>\n            <th><span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_IP"></span></th>\n            <th><span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_DATE"></span></th>\n            <th><span class="i18n" data-i18n="ACCOUNTS.USERS.LBL_USER_AGENT"></span></th>\n          </tr>\n          </thead>\n          <tbody>\n          ';
 $.each(listLoginHistoryModel.attributes, function (index, loginHistory) { ;
__p += ' ';
 if(loginHistory.date){ ;
__p += '\n          <tr>\n            <td>\n              <i class="ayuda-context-login-history ' +
__e( ((loginHistory.isValid)?" verde fa fa-check-circle-o":"naranja fa fa-times-circle-o") ) +
'" tabindex="0" role="button" data-template=\'\n              <div class="popover" role="tooltip" style="width: auto;max-width: 500px;">\n                <div class="arrow"></div>\n                <div class="popover-content helpers-text"></div>\n              </div>\n              \' data-toggle="popover" data-i18n="[data-content]' +
__e( ((loginHistory.isValid)?"ACCOUNTS.USERS.HELP_OK":"ACCOUNTS.USERS.HELP_KO") ) +
'" data-trigger="focus" data-html="true" data-placement="bottom" data-container="body"></i>\n            </td>\n            ';
if (loginHistory.service_id != null) {;
__p += '\n            <td><span class="i18n" data-i18n="ACCOUNTS.COMPANIES.LBL_SERVICE_' +
__e( loginHistory.service_id) +
'"></span></td>\n            ';
} else {;
__p += '\n            <td>--</td>\n            ';
};
__p += ' ';
if (loginHistory.ip != null) {;
__p += '\n            <td>' +
__e( loginHistory.ip) +
'</td>\n            ';
} else {;
__p += '\n            <td>--</td>\n            ';
};
__p += '\n            <td>' +
__e( loginHistory.date) +
'</td>\n            <td>' +
__e( listLoginHistoryModel.renderUserAgent(loginHistory.user_agent)) +
'</td>\n          </tr>\n          ';
 } ;
__p += ' ';
 }); ;
__p += '</tbod\n        </table>\n      </div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

